import React from 'react';
import { Box, costFormater, Text } from '@common-fe/common-fe';

import { useGetTransactionsInfoQuery } from './queries';
interface Props {
  accountId: string;
}
const EmployeeCIPCloseInfo: React.FC<Props> = ({ accountId }) => {
  const { data } = useGetTransactionsInfoQuery({
    accountId,
  });
  return (
    <Box>
      <Box
        data-testid="cip_info"
        background="canvas"
        pad="spacing24"
        round="container1Round"
        border={{ size: 'small', color: 'border2' }}
        direction="column"
      >
        <Box direction="row" align="center" pad={{ vertical: 'spacing8' }}>
          <Box width="220px" margin={{ right: 'spacing24' }}>
            <Text size="medium" weight={700}>
              Total Contributions
            </Text>
          </Box>
          <Box style={{ flex: 3 }}>
            <Text size="large" data-testid="cip_info_total" weight={400}>
              {costFormater(data?.totalContributions || 0, { isPrecision: true })}
            </Text>
          </Box>
        </Box>

        {!!data?.pendingTransfer && (
          <Box direction="row" align="center" pad={{ vertical: 'spacing8' }}>
            <Box width="220px" margin={{ right: 'spacing24' }}>
              <Text size="medium" weight={700}>
                Pending Transfers Credits
              </Text>
            </Box>
            <Box style={{ flex: 3 }}>
              <Text size="large" data-testid="cip_info_pending" weight={400}>
                {costFormater(data?.pendingTransfer, { isPrecision: true })}
              </Text>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default EmployeeCIPCloseInfo;
